import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=cc98670c&scoped=true"
import script from "./Sidemenu.vue?vue&type=script&lang=js"
export * from "./Sidemenu.vue?vue&type=script&lang=js"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&id=cc98670c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc98670c",
  null
  
)

export default component.exports